import * as MentionsPickerConstants from '../constants';
import MentionPluginDataProvider from '../providers/MentionPluginDataProvider';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import { PluginViewStateAdapter } from 'owa-editor';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import ScrollAdapter from 'owa-scroll-adapter/lib/ScrollAdapter';
import { PickerPluginOptions } from 'roosterjs-plugin-picker/lib/PickerDataProvider';
import EditorPickerPlugin from 'roosterjs-plugin-picker/lib/PickerPlugin';

export default class AtMentionPickerPlugin extends EditorPickerPlugin<MentionPluginDataProvider> {
    constructor(
        adapter: PluginViewStateAdapter<AtMentionsViewState>,
        scrollAdapter: ScrollAdapter,
        targetRecipientWell: RecipientWellWithFindControlViewState,
        onRecipientAdded: () => void,
        canModifyRecipients: boolean,
        getAllRecipients: () => ReadWriteRecipientViewState[]
    ) {
        const provider = new MentionPluginDataProvider(
            adapter,
            scrollAdapter,
            targetRecipientWell,
            onRecipientAdded,
            canModifyRecipients,
            getAllRecipients
        );
        const pickerOptions: PickerPluginOptions = {
            elementIdPrefix: MentionsPickerConstants.AT_MENTION_ELEMENT_ID_PREFIX,
            changeSource: MentionsPickerConstants.AT_MENTION_CHANGE_SOURCE,
            triggerCharacter: MentionsPickerConstants.AT_MENTION_TRIGGER_CHARACTER,
            suggestionsLabel: MentionsPickerConstants.AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL,
            suggestionLabelPrefix:
                MentionsPickerConstants.AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX,
        };

        super(provider, pickerOptions);
    }

    public getName() {
        return 'AtMentionsPicker';
    }
}
